<template>
  <div class="question">
    <div class="question_content">
      <div class="que_head">
        <p :class="{'que_active':isanswer}" @click="isanswer=true">
          <img v-show="!isanswer" src="../../assets/community/answer_icon_nor@2x.png" alt srcset />
          <img v-show="isanswer" src="../../assets/community/ans_icon_pre@2x.png" alt srcset />
          回答
        </p>
        <p :class="{'que_active':!isanswer}" @click="isanswer=false">
          <img v-show="isanswer" src="../../assets/community/que_icon_nor@2x.png" alt srcset />
          <img v-show="!isanswer" src="../../assets/community/que_icon_pre@2x.png" alt srcset />
          提问
        </p>
      </div>
      <div
        v-show="isanswer&&answerArr.length!=0"
        class="answerlist infinite-list"
        ref="scrollList"
        v-infinite-scroll="pushnext"
        infinite-scroll-disabled="isquestionall"
        infinite-scroll-distance="10"
        infinite-scroll-immediate="false"
      >
        <div v-for="(item,index) in answerArr" class="answerli" :key="index">
          <p class="questiontitle" @click="goquestiondetail(item,2)">{{item.question_title}}</p>
          <!-- 问题有回答 -->
          <div class="hasanswer">
            <!-- 回答是否有图片 -->
            <div v-if="item.answer.img" class="haspicture">
              <div
                alt
                class="hasimage"
                :style=" {backgroundImage:'url('+item.answer.img+')'}"
                style="background-size: cover;background-position: center center;"
                v-show="!item.answer.is_detail"
              ></div>
              <div class="answercon" @click="lookmore(index,item)" v-show="!item.answer.is_detail">
                {{item.answer.content}}
                <span class="hasmore">
                  显示全部
                  <sub></sub>
                </span>
              </div>
              <div class="ishasmore" v-show="item.answer.is_detail">
                <viewer><pre class="detail_content" v-html="item.answer.detail_content"></pre></viewer>
              </div>
            </div>
            <div v-else class="nopicture">
              <div
                class="nopircontent"
                @click="lookmore(index,item)"
                v-show="!item.answer.is_detail"
              >
                <div>{{item.answer.content}}</div>
                <span class="hasmore">
                  显示全部
                  <sub></sub>
                </span>
              </div>
              <div class="nopircontent2" v-show="item.answer.is_detail">
                <viewer><pre class="detail_content" v-html="item.answer.detail_content"></pre></viewer>
              </div>
            </div>
            <p class="answer_time" v-show="item.answer.is_detail">发布于{{item.answer.answer_time}}</p>
            <div class="answer_evaluate">
              <p
                class="answer_star"
                v-show="!item.answer.is_star"
                @click="tostar(item.answer.answer_id,index)"
              >
                <strong class="star_span"></strong>
                <span v-show="item.answer.star_count!=0">{{item.answer.star_count}}个</span>点赞
              </p>
              <p
                v-show="item.answer.is_star"
                @click="cancelstar(item.answer.answer_id,index)"
                style="color:#D55D3A;"
                class="answer_cancelstar"
              >
                <img src="../../assets/community/hand_icon_does.png" alt />
                {{item.answer.star_count}}个点赞
              </p>
              <p
                class="answer_comment"
                v-show="!commentisArr[index]"
                @click="setcomment(index,item.answer.answer_id,1)"
              >
                <strong></strong>
                <span v-show="item.answer.comment_count!=0">{{item.answer.comment_count}}条</span>评论
              </p>
              <p
                class="answer_comment"
                v-show="commentisArr[index]"
                @click="setcomment(index,item.answer.answer_id,2)"
              >
                <strong></strong>收起评论
              </p>
              <div
                class="closeanswer"
                v-show="item.answer.is_detail"
                @click="item.answer.is_detail=!item.answer.is_detail"
              >
                收起回答
                <span></span>
              </div>
            </div>
            <div class="answer_comments" v-show="commentisArr[index]">
              <p
                class="comment_count"
                v-show="commentArr[index].comments.length != 0"
              >{{commentArr[index].total_count}}条评论</p>
              <div v-show="commentArr[index].comments.length != 0">
                <div
                  class="comment_li"
                  v-for="(citem,cindex) in commentArr[index].comments"
                  :key="cindex"
                >
                  <p class="comment_username">{{citem.user_name}}</p>
                  <pre class="comment_comtent" v-html="citem.content"></pre>
                  <p class="comment_time">{{citem.create_time}}</p>
                  <p
                    class="comment_detele"
                    v-if="userid == citem.user_id"
                    @click="comment_delete(item.answer.answer_id,citem.comment_id,index)"
                  >删除</p>
                </div>
              </div>
              <div v-show="commentArr[index].comments.length == 0" class="notcomment">
                <p class="comment_count">还没有评论</p>
                <!-- <span>没有评论~<span>现在去添加第一个吧~</span></p> -->
              </div>
              <div class="pagination" v-if="commentArr[index].total_pages>1">
                <el-pagination
                  @prev-click="handlePre($event,index,item)"
                  @next-click="handleNext($event,index,item)"
                  @current-change="changePage($event,index,item)"
                  prev-text="上一页"
                  next-text="下一页"
                  :current-page="commentArr[index].current_page"
                  layout="prev, pager, next"
                  :page-size="1"
                  :total="commentArr[index].total_pages"
                ></el-pagination>
              </div>
              <div class="comment_answer">
                <!-- <input type="text" placeholder="写下你的评论..." v-model="item.commentsub" /> -->
                <el-input
                  class="comment_input"
                  type="textarea"
                  autosize
                  placeholder="写下你的评论..."
                  v-model="item.commentsub"
                ></el-input>
                <button @click="comment_submit(item,index)">发表</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noanswerlist" v-show="isanswer&&answerArr.length==0">
        <img @click="gocommunity" src="../../assets/community/img_que.png" alt="" srcset="">
        <p @click="gocommunity">没有回答~<span>现在去添加一个吧~</span></p>
      </div>
      <div class="noanswerlist" v-show="!isanswer&&questionArr.length==0">
        <img @click="gocommunity" src="../../assets/community/img_answer@2x.png" alt="" srcset="">
        <p @click="gocommunity">没有提问~<span>现在去添加一个吧~</span></p>
      </div>
      <div class="questionlist" v-show="!isanswer">
        <div class="questionli" v-for="(item,index) in questionArr" :key="index">
          <p class="que_title" @click="goquestiondetail(item,2)">{{item.question_title}}</p>
          <p class="que_time">
           <span v-if="item.create_time!=''&&item.create_time!=null">{{item.create_time}}</span>
            {{item.answer_count}}个回答
          </p>
        </div>
      </div>
    </div>
    <div class="img_open" v-show="openimg">
      <img :src="openimg_img" class="openimg_img" @click="openimg = !openimg" />
    </div>
  </div>
</template>
<script>
import { distance } from "../../util/gettime";
import {addstamp} from '../../util/stamp';
export default {
  data() {
    return {
      userid:null,
      activeName: "second",
      isanswer: true,
      answerArr: [],
      questionArr: [],
      bgimg: [
        require("../../assets/community/headimg/User_icon_1.png"),
        require("../../assets/community/headimg/User_icon_2.png"),
        require("../../assets/community/headimg/User_icon_3.png"),
        require("../../assets/community/headimg/User_icon_4.png")
      ],
      imgbg: [],
      commentisArr: [],
      commentArr: [],
      currentpage: 1,
      pagesize: 5,
      total_pages: null,
      openimg: false,
      openimg_img: null
    };
  },
  created() {
    this.loadanswerlist();
    this.loadquestionlist();
    this.userid = parseInt(this.$store.state.user_id);
  },
  methods: {
    gocommunity(){
      this.$router.push({path: "/community"});
    },
    loadanswerlist() {
      var that = this;
      var params = {
        user_id: parseInt(this.$store.state.user_id),
        page: 1,
        page_size: 10
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      var url = "community/self/answer/" + parseInt(this.$store.state.user_id);
      this.$axios.get(url, { params }).then(function(res) {
        // console.log(res);
        that.answerArr = res.data.data.questions;
        that.total_pages = res.data.data.total_pages;
        that.currentpage = res.data.data.current_page;
        // if(that.keyword != ''||that.keyword != null){
        // }else{
        if (res.data.status_code == 200) {
          var imgarr = [];
          for (var j = 0; j < res.data.data.questions.length; j++) {
            imgarr.push(that.bgimg[parseInt(4 * Math.random())]);
          }

          if (that.currentpage == 1) {
            that.answerArr = res.data.data.questions;
            that.answerArr = res.data.data.questions;
            that.imgbg = imgarr;
          } else {
            that.answerArr = that.answerArr.concat(res.data.data.questions);
            that.imgbg = that.imgbg.concat(imgarr);
          }
          for (var i = 0; i < that.answerArr.length; i++) {
            if (that.answerArr[i].answer.content.length > 136) {
              var sub = that.answerArr[i].answer.content.substring(0, 136);
              that.answerArr[i].answer.content = sub;
            }
            that.commentisArr.push(false);
            that.commentArr.push({
              current_page: 1,
              total_pages: 1,
              total_count: 0,
              comments: []
            });
              // console.log(that.answerArr[i].answer.answer_time)
            if (that.answerArr[i].answer.answer_time) {
              that.answerArr[i].answer.answer_time = that.answerArr[
                i
              ].answer.answer_time.split(" ")[0];
            }
          }
          // console.log(that.answerArr)
          // }
        }
      });
    },
    loadquestionlist() {
      var that = this;
      var params = {
        user_id: parseInt(this.$store.state.user_id),
        page: 1,
        page_size: 10
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      var url =
        "community/self/question/" + parseInt(this.$store.state.user_id);
      this.$axios.get(url, { params }).then(function(res) {
        that.questionArr = res.data.data.questions;
        // console.log(res);
        for (var i = 0; i < that.questionArr.length; i++) {
          that.questionArr[i].create_time = that.questionArr[i].create_time.split(" ")[0]
        }
      });
    },
    pushnext() {
      if (this.currentpage != this.total_pages) {
        this.currentpage += 1;
        if (this.isanswer) {
          this.loadanswerlist();
        } else {
          this.loadquestionlist();
        }
      }
    },
    lookmore(index, item) {
      this.answerArr[index].answer.is_detail = !this.answerArr[index].answer
        .is_detail;
    },
    goquestiondetail(item, num) {
      this.$router.push({
        path: "/questionDetails",
        query: {
          qd: item.question_id,
          a: num
        }
      });
    },
    comment_submit(item, index) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        content: item.commentsub,
        id:item.answer.answer_id
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      //   console.log(item.commentsub);
      let url = "community/" + item.answer.answer_id + "/comment";
      this.$axios.post(url, params).then(function(res) {
        that.commentArr[index].current_page = 1;
        that.answerArr[index].answer.comment_count += 1;
        that.loadlistcomment(index, item.answer.answer_id);
        that.answerArr[index].commentsub = "";
      });
    },
    comment_delete(itemid, comment_id, index) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        comment_id: comment_id,
        id:itemid,
        type : "answer"
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      //   console.log(params);
      let url = "community/" + itemid + "/comment";
      this.$axios.delete(url, { params }).then(function(res) {
        console.log(res);
        // console.log(that.answerArr)
        that.answerArr[index].answer.comment_count -= 1;
        that.commentArr[index].current_page = 1;
        that.loadlistcomment(index, itemid);
      });
    },
    loadlistcomment(index, id) {
      // console.log(id)
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        page: this.commentArr[index].current_page,
        page_size: 15,
        id:id
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      let url = "community/" + id + "/comments";
      this.$axios.get(url, { params })
      .then(function(res) {
        that.commentArr[index].current_page = res.data.data.current_page;
        that.commentArr[index].total_pages = res.data.data.total_pages;
        that.commentArr[index].total_count = res.data.data.total_count;
        that.commentArr[index].comments = res.data.data.comments;
        for (var i = 0; i < that.commentArr[index].comments.length; i++) {
          that.commentArr[index].comments[i].create_time = distance(
            that.commentArr[index].comments[i].create_time
          );
        }
      });
    },
    setcomment(index, id, num) {
      if (num == 1) {
        this.$set(this.commentisArr, index, true);
        this.loadlistcomment(index, id);
      } else {
        this.$set(this.commentisArr, index, false);
      }
    },
    tostar(id, index) {
      let that = this;
      let params = {
        user_id: this.userid,
        answer_id:id
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      let url = "community/" + id + "/star";
      this.$axios
        .post(url, params)
        .then(function(res) {
          // console.log(res.data)
          if (res.data.status_code == 200) {
            that.answerArr[index].answer.is_star = true;
            that.answerArr[index].answer.star_count += 1;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    cancelstar(id, index) {
      let that = this;
      let params = {
        user_id: this.userid,
        answer_id: id
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      let url = "community/" + id + "/star";
      this.$axios.put(url, params).then(function(res) {
          // console.log(res.data)
        if (res.data.status_code == 200) {
          that.answerArr[index].answer.is_star = false;
          that.answerArr[index].answer.star_count -= 1;
        }
      });
    },
  },
  watch:{
    openimg() {
      if (this.openimg) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $('body').removeAttr('style')
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.question {
  width: 100%;
  padding-bottom: 1px;
  .question_content {
    width: 1200px;
    // height: 500px;
    background: #fff;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 67px;
    .que_head {
      // display: flex;
      width: 842px;
      margin: 0 auto;
      border-bottom: 1px solid #dcdcdc;
      padding-top: 36px;
      // margin-bottom: 40px;
      p {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 28px;
          height: 28px;
          vertical-align: middle;
        }
      }
      .que_active {
        border-bottom: 2px solid #d55d3a;
        z-index: 99;
        color: #d55d3a;
      }
    }
    .noanswerlist{
       width: 824px;
       padding: 150px 0px;
       margin: 0 auto;
      // border: 1px solid red;
      img{
        display: block;
        width: 506px;
        height: 169px;
        margin: 0 auto;
        cursor: pointer;
      }
      p{
        text-align: center;
        cursor: pointer;
        color: #666;
        margin-top: 40px;
        span{
          color: #D55D3A;
        }
      }
    }
    .questionlist {
      width: 824px;
      margin: 0 auto;
      padding-bottom: 15px;
      .questionli {
        width: 100%;
        border-bottom: 1px solid #dcdcdc;
        margin-top: 30px;
        margin-bottom: 30px;
        .que_title {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #333;
          cursor: pointer;
        }
        .que_time {
          color: #999;
          margin-top: 17px;
          margin-bottom: 12px;
          span {
            margin-right: 20px;
          }
        }
      }
    }
    .answerlist {
      background: #fff;
      padding-bottom: 75px;
    }
    // .answerli:last-child {
    //   border-bottom: 0px solid #dcdcdc;
    // }
    .answerli {
      width: 847px;
      margin: 0 auto;
      padding-top: 30px;
      border-bottom: 1px solid #dcdcdc;
      .questiontitle {
        width: 100%;
        font-size: 20px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #333;
        cursor: pointer;
      }
      .iwantanswer {
        width: 117px;
        height: 35px;
        line-height: 35px;
        border-radius: 8px;
        border: 1px solid #d55d3a;
        color: #d55d3a;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 38px;
        cursor: pointer;
        span {
          width: 20px;
          height: 20px;
          vertical-align: middle;
          display: inline-block;
          margin-top: -4px;
          background: url(../../assets/community/pen_icon.png) center center
            no-repeat;
        }
      }
      .answer_name {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
      }
      .answer_name_detail {
        display: inline-block;
        text-align: center;
        background: rgba(243, 243, 243, 1);
        border-radius: 36px;
        padding: 5px 9px;
        line-height: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        img {
          width: 26px;
          height: 26px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
      }
      .hasanswer {
        width: 100%;
        margin-top: 20px;
        .haspicture {
          width: 100%;
          min-height: 130px;
          display: flex;
          .hasimage {
            width: 160px;
            height: 106px;
            display: inline-block;
          }
          .answercon {
            display: inline-block;
            width: 660px;
            height: 106px;
            box-sizing: border-box;
            margin-left: 20px;
            line-height: 28px;
            cursor: pointer;
          }
          .ishasmore {
            cursor: pointer;
          }
        }
      }
      .hasmore {
        color: #d55d3a;
        font-family: PingFangSC-Regular;
        font-weight: 600;
        cursor: pointer;
        sub {
          width: 20px;
          height: 20px;
          display: inline-block;
          background: url(../../assets/community/alldown_icon_nor.png) center
            center no-repeat;
        }
        &:hover {
          color: #e83700;
          sub {
            background: url(../../assets/community/alldown_icon_pre.png) center
              center no-repeat;
          }
        }
      }
      .nopicture {
        width: 100%;
        margin-top: 28px;
        margin-bottom: 20px;
        cursor: pointer;
        .nopircontent {
          line-height: 28px;
          width: 100%;
          div {
            display: inline;
            white-space: pre-wrap; /* css3.0 */
            white-space: -moz-pre-wrap; /* Firefox */
            white-space: -pre-wrap; /* Opera 4-6 */
            white-space: -o-pre-wrap; /* Opera 7 */
            word-wrap: break-word;
          }
          span {
            display: inline;
          }
        }
        .nopircontent2 {
          width: 100%;
        }
      }
      .answer_time {
        width: 850px;
        margin: 0 auto;
        margin-bottom: 20px;
        color: #999;
      }
      .answer_evaluate {
        width: 100%;
        height: 24px;
        line-height: 24px;
        color: #ad896b;
        // display: flex;
        margin-bottom: 30px;
        p {
          margin-right: 26px;
          display: inline-block;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
          strong {
            width: 24px;
            height: 24px;
            // margin-right: 4px;
            display: inline-block;
            vertical-align: middle;
          }
          &:hover {
            color: #9d7a5c;
          }
        }
        .answer_star {
          .star_span {
            background: url(../../assets/community/hand_icon_nor.png) center
              center no-repeat;
            vertical-align: top;
          }
          &:hover {
            .star_span {
              background: url(../../assets/community/hand_icon_pre.png) center
                center no-repeat;
            }
          }
        }
        .answer_cancelstar {
          img {
            vertical-align: top;
          }
        }
        .answer_comment {
          strong {
            background: url(../../assets/community/com_icon_nor.png) center
              center no-repeat;
          }
          &:hover {
            strong {
              background: url(../../assets/community/com_icon_pre.png) center
                center no-repeat;
            }
          }
        }
        .closeanswer {
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(173, 137, 107, 1);
          line-height: 24px;
          float: right;
          cursor: pointer;
          margin-right: 5px;
          span {
            display: inline-block;
            width: 24px;
            height: 24px;
            vertical-align: top;
            background: url(../../assets/community/Packup_icon_nor.png);
          }
          &:hover {
            color: #9d7a5c;
            span {
              background: url(../../assets/community/Packup_icon_pre.png);
            }
          }
        }
      }
      .answer_comments {
        width: 840px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 8px 0px rgba(6, 5, 4, 0.11);
        border: 1px solid transparent;
        .comment_count {
          margin-top: 20px;
          margin-left: 20px;
          font-family: PingFang SC;
          font-weight: 600;
        }
        .comment_li {
          width: 798px;
          margin: 0 auto;
          border-bottom: 1px solid #e5e5e5;
          padding-top: 20px;
          padding-bottom: 20px;
          position: relative;
          .comment_username {
            font-family: PingFang SC;
            font-weight: 600;
          }
          .comment_comtent {
            width: 712px;
            font-family: PingFang SC;
            font-weight: 400;
            margin-top: 3px;
            white-space: pre-wrap; /* css3.0 */
            white-space: -moz-pre-wrap; /* Firefox */
            white-space: -pre-wrap; /* Opera 4-6 */
            white-space: -o-pre-wrap; /* Opera 7 */
            word-wrap: break-word;
          }
          .comment_time {
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            position: absolute;
            top: 43px;
            right: 0;
            // border: 1px solid red;
          }
          .comment_detele {
            color: #987659;
            margin-top: 10px;
            font-family: PingFang SC;
            font-weight: 400;
            cursor: pointer;
          }
        }
      }
    }
  }
  .answer_comments {
    width: 840px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 8px 0px rgba(6, 5, 4, 0.11);
    border: 1px solid transparent;
    .comment_count {
      margin-top: 20px;
      margin-left: 20px;
      font-family: PingFang SC;
      font-weight: 600;
    }
    .comment_li {
      width: 798px;
      margin: 0 auto;
      border-bottom: 1px solid #e5e5e5;
      padding-top: 20px;
      padding-bottom: 20px;
      position: relative;
      .comment_username {
        font-family: PingFang SC;
        font-weight: 600;
      }
      .comment_comtent {
        width: 712px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-top: 3px;
        white-space: pre-wrap; /* css3.0 */
        white-space: -moz-pre-wrap; /* Firefox */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word;
      }
      .comment_time {
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        position: absolute;
        top: 43px;
        right: 0;
        // border: 1px solid red;
      }
      .comment_detele {
        color: #987659;
        margin-top: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
  .notcomment {
    width: 100%;
    height: 20px;
  }
  .comment_answer {
    width: 810px;
    // height: 45px;
    margin: 0 auto;
    position: relative;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 18px;
    display: flex;
    justify-content: space-around;
    // .comment_input {
    //   width: 700px;
    //   float: left;
    // }
    button {
      width: 98px;
      height: 44px;
      display: inline-block;
      background: rgba(213, 93, 58, 1);
      border-radius: 8px;
      margin-left: 10px;
      border: none;
      color: #fff;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      cursor: pointer;
      position: absolute;
      bottom: 0px;
      right: 0px;
    }
  }
  .ask_content {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.63);
    .closetagbox {
      cursor: pointer;
      // border: 1px solid red;
      width: 30px;
      height: 30px;
      position: absolute;
      top: calc(50% - 190px);
      left: calc(50% + 370px);
      background: url(../../assets/community/close.png) no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
.img_open {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  /* border: 1px solid red; */
  background: rgba(26, 26, 26, 0.65);
  border-radius: 6px;
  padding-bottom: 10px;
  .openimg_img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    margin: 0 auto;
    cursor: -moz-zoom-out;
    cursor: -webkit-zoom-out;
    cursor: zoom-out;
  }
}
</style>
<style>
.detail_content {
  width: 100%;
  /* border: 1px solid red; */
  line-height: 36px;
  font-size: 16px;
  white-space: pre-wrap; /* css3.0 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word;
}
.answerli .detail_content img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.answer_comments .pagination {
  margin: 10px auto 30px;
  width: 100%;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
}
.answer_comments .el-pagination button:hover {
  color: #d55d3a;
}

.el-pagination button:disabled:hover {
  color: #c0c4cc;
}
.answer_comments .el-icon-arrow-left:before,
.answer_comments .el-icon-arrow-right:before {
  /* content: "上一页"; */
  font-size: 16px;
}
.answer_comments .el-pager li.active,
.el-pager li:hover,
.answer_comments .el-icon-arrow-left:hover,
.answer_comments .el-icon-arrow-right:hover {
  color: #d55d3a;
}
.comment_input .el-textarea__inner {
  width: 700px;
  padding-top: 10px;
  background: #f3ede9;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  /* text-indent: 22px; */
  color: #333;
  outline: none;
}
.comment_input .el-textarea__inner::placeholder {
  color: #a8978c;
}
</style>


// WEBPACK FOOTER //
// src/components/page/myquestion.vue